import axios from 'axios';

const state = {
    chat_gpt: "",
};

const getters = {

};

const actions = {
    chatgpt_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_test_key({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/test-key', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_test(context, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/test', {
                message: data.message,
                number: data.number || null,
                file: data.file || null,
                quoted_message: data.quoted_message || null
            })
                .then(response => {
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_summaries(context, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/summaries', {
                params: {
                    number: data.number || null,
                    limit: data.limit || 10
                }
            })
                .then(response => {
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_threads(context, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/threads', {
                params: {
                    number: data.number || null,
                    limit: data.limit || 10
                }
            })
                .then(response => {
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('chat-gpt/' + data.id, data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_duplicate({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/duplicate', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_update_jam_kerja({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('chat-gpt/' + data.id + '/jam-kerja', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_update_ongkir({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('chat-gpt/' + data.id + '/ongkir', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_dataset_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.chatgpt_id + '/datasets', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_dataset_export({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.chatgpt_id + '/datasets/export', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_media_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.chatgpt_id + '/media', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_history_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.chatgpt_id + '/history', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_device_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.chatgpt_id + '/devices', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chat_gpt_add_device({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.chatgpt_id + '/devices', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_device_change_status({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('chat-gpt/' + data.chatgpt_id + '/devices/' + data.device_id, { status: data.status })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_device_delete({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.chatgpt_id + '/devices/' + data.device_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_topup({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.chatgpt_id + '/buy', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_dataset_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/datasets', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_media_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/media', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_dataset_get({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/datasets/' + data.dataset_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_media_get({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/media/' + data.media_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_dataset_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('chat-gpt/' + data.id + '/datasets/' + data.dataset_id, data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_media_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('chat-gpt/' + data.id + '/media/' + data.media_id, data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_dataset_bulk_delete({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/datasets/bulk-delete', {
                dataset_ids: data.dataset_ids,
            })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_dataset_delete_all({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.id + '/datasets')
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_delete_dataset({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.id + '/datasets/' + data.dataset_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_delete_media({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.id + '/media/' + data.media_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_delete_history({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.id + '/history/' + data.history_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_train({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/train')
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_delete({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_detail({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_token({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/calculate-token')
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_rule_create_or_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/rules', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    location_search({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('location/search', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_blacklist_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/blacklist', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_create_blacklist({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/blacklist', { number: data.number })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_delete_blacklist({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.id + '/blacklist/' + data.blacklist_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_blacklist_keyword_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/blacklist-keyword', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_create_blacklist_keyword({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('chat-gpt/' + data.id + '/blacklist-keyword', {
                keyword: data.keyword,
                match_type: data.match_type || 'match'
            })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_delete_blacklist_keyword({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('chat-gpt/' + data.id + '/blacklist-keyword/' + data.keyword_id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_error_log_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('chat-gpt/' + data.id + '/error-logs', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_provider_list({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('admin/chat-gpt/providers', { params: data })
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_create_provider({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('admin/chat-gpt/provider', data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_provider_detail({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('admin/chat-gpt/provider/' + data.id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_update_provider({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('admin/chat-gpt/provider/' + data.id, data)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    chatgpt_delete_provider({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('admin/chat-gpt/provider/' + data.id)
                .then(response => {
                    commit("PUSH_CHATGPT", "OK")
                    resolve(response)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
}

const mutations = {
    PUSH_CHATGPT(state, data) {
        state.chat_gpt = data
    },
};


export default {
    state,
    getters,
    actions,
    mutations
};
